import PropTypes from 'prop-types'
import { UniversityProgramPageQuery, UNIVERSITY_PROGRAM_QUERY } from '@layouts/university-program'
import { fetchSSRData } from '@lib/ssr-fetch'

function UniversityProgramPage(props) {
  const { data: ssrData, ...restProps } = props
  return (
    <UniversityProgramPageQuery {...restProps} ssrData={ssrData} />
  )
}

UniversityProgramPage.propTypes = {
  data: PropTypes.object,
}

UniversityProgramPage.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: UNIVERSITY_PROGRAM_QUERY,
  variables: { pageSlug: '/university-program' },
  transform: (data) => data?.associateProgramCollection?.items[0] || null,
})

export default UniversityProgramPage
